<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row
      class="d-flex"
    >
      <v-card
        flat
        class="card-full-width text-center"
      >
        <span class="section-header">Frequently Asked Questions</span>
      </v-card>

      <v-card
        flat
        class="card-full-width pa-3 mt-0"
      >
        <p
          class="section-subheader mb-n1"
        >
          What payment methods are accepted?
        </p>
        <p
          class="section-text"
        >
          {{ businessName }} currently accepts the following methods:
        </p>
        <ul>
          <li>
            E-Check/ACH - Direct withdrawal from bank
          </li>
          <li>
            Visa
          </li>
          <li>
            Mastercard
          </li>
          <li>
            Physical check mailed in to <b>PO Box 6, Escalon, CA, 95320</b> or dropped off in the mail slot at <b>1525 2nd st, Escalon, CA, 95320</b>
          </li>
          <li>
            Cash in person at <b>1525 2nd st, Escalon, CA, 95320</b>
          </li>
        </ul>
      </v-card>
      <v-card
        flat
        class="card-full-width pa-3 mt-0"
      >
        <p
          class="section-subheader mb-n1"
        >
          When are invoices due?
        </p>
        <p
          class="section-text"
        >
          Invoices are due at the 1st of the month.
        </p>
      </v-card>
      <v-card
        flat
        class="card-full-width pa-3 mt-0"
      >
        <p
          class="section-subheader mb-n1"
        >
          How do I configure e-mail on my devices?
        </p>
        <p
          class="section-text"
        >
          Every device has its challenges when configuring email.
          Our email provider has an excellent toolthat you can use
          to guide you through the steps.You will be prompted to
          enter your email address and password as it will provide
          images and detailed steps with that information specific to your device
        </p>
        <p>
          <v-btn
            tile
            block
            color="secondary"
            link
            href="https://help.emailsrvr.com/"
          >
            Email Help
          </v-btn>
        </p>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'Faq',
    mixins: [basicMixin],

    data () {
      return {
      }
    },
    computed: {
    },
    async created () {
    },
    methods: {
    },
  }
</script>
